import React, { Fragment, useEffect } from 'react';
import cs from 'classnames';
// import './index.less'
import styles from './index.less';
import SMS from '../Sms';
import { TLang } from '@/utils/lang';

const prefix = 'qyf';

const Inputted = (props: any) => {
  const { type } = props;

  useEffect(() => {
    console.log('lliuyg', props.values);
  }, [props.values]);

  /**
   * Inputted 渲染3种展示效果
   * 4位密码 password
   * 11位手机号 phone
   * 6位短信验证码 sms
   */
  const Password = ({
    warnText = '',
    values = [],
    isShowTip = true,
    callback
  }) => {
    console.log('callback', values);
    return (
      <div className={`${styles.qyfInputtedContianer}`}>
        <div className={`${styles.qyfPoint}`}>{warnText}</div>
        <ul className={`${styles.qyfContent}`}>
          <li>
            <div className={`${styles.qyLable}`}>
              <span
                className={`${styles.qyfNo} ${styles[values[0] && 'have']}`}
              />
            </div>
          </li>
          <li>
            <div className={`${styles.qyLable}`}>
              <span
                className={`${styles.qyfNo} ${styles[values[1] && 'have']}`}
              />
            </div>
          </li>
          <li>
            <div className={`${styles.qyLable}`}>
              <span
                className={`${styles.qyfNo} ${styles[values[2] && 'have']}`}
              />
            </div>
          </li>
          <li>
            <div className={`${styles.qyLable}`}>
              <span
                className={`${styles.qyfNo} ${styles[values[3] && 'have']}`}
              />
            </div>
          </li>
        </ul>
        {isShowTip && (
          <div
            className={`${styles.qyfTip}`}
            onTouchStart={() => {
              callback && callback();
            }}
          >
            {TLang('忘记密码', 'home', false, false, null)}
          </div>
        )}
      </div>
    );
  };
  const Phone = ({ values = [], callback, warnText = '' }) => {
    const defaultValue = TLang('请输入11位手机号', 'home', false, false, null);
    // 手机号输入11位，发送按钮激活
    const isDisabled = values.length < 11;
    return (
      <div
        className={`${styles.qyfInputtedContianer} ${styles.qyfContainPhone}`}
      >
        <div className={`${styles.qyfPoint}`}>{warnText}</div>
        <div className={`${styles.qyfPhone}`}>
          {values.length === 0 ? (
            <>
              <span className={`${styles.cursorBlink}`}>{defaultValue}</span>
              <p className={`${styles.animation}`}></p>
            </>
          ) : (
            <span className={`${styles.qyfPhoneText}`}>{values}</span>
          )}
        </div>
        <div
          onTouchStart={() => {
            if (isDisabled) return;
            callback && callback();
          }}
          className={`${styles.qyfTip} ${styles.qyfTipPhone} ${styles[isDisabled && 'qyfTipDisabled']
            }`}
        >
          <span>{TLang('发送验证码', 'home', false, false, null)}</span>
        </div>
      </div>
    );
  };

  const renderInputType = (type) => {
    switch (type) {
      case 'password':
        return <Password {...props} />;
      case 'phone':
        return <Phone {...props} />;
      case 'sms':
        return <SMS {...props} />;
      default:
        return null;
    }
  };

  return <div>{renderInputType(type)}</div>;
};

export default Inputted;
